module.exports = __webpack_public_path__ + "static/media/avg.1382eab0.png";